package com.appcreator.client.revenuecat

internal actual suspend fun loadManageSubscriptionsUrl(): String? = null